export const LOADING_LOCALE = {
    message: 'Loading ...'
};
